import { useEffect, useRef } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

/**
 * Attempts silent authentication on mount when user is not authenticated.
 * Enables SSO: if user logged in on another app (same Auth0 tenant), we pick up the session
 * without requiring them to click Log In again.
 */
export default function Auth0SSOGuard({ children }) {
  const { isAuthenticated, isLoading, getAccessTokenSilently } = useAuth0();
  const attemptedRef = useRef(false);

  useEffect(() => {
    if (isLoading || isAuthenticated || attemptedRef.current) return;
    attemptedRef.current = true;

    const trySilentAuth = async () => {
      try {
        await getAccessTokenSilently({
          authorizationParams: {
            audience: process.env.REACT_APP_AUTH0_AUDIENCE,
            scope: 'openid profile email offline_access',
            prompt: 'none',
          },
          cacheMode: 'off',
        });
      } catch {
        // No session - user stays logged out
      }
    };

    trySilentAuth();
  }, [isLoading, isAuthenticated, getAccessTokenSilently]);

  return children;
}
